import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import getStyles from './styles';

class TextInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.input = React.createRef();
        this.counter = React.createRef();

        this.state = {
            value: props.value,
            input_focused: false,
        };
    }

    static propTypes = {
        value: PropTypes.string,
        max_length: PropTypes.number,
        element_props: PropTypes.object,
        icon: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        mobile: PropTypes.bool,
        className: PropTypes.string,
        t: PropTypes.func.isRequired,
    };

    static defaultProps = {
        element_props: {},
        mobile: false,
    };

    componentDidUpdate(prev_props) {
        if (this.props.value !== prev_props.value) {
            this.setState({ value: this.props.value });
        }
    }

    handleChange = event => {
        const { value } = event.target;

        this.setState({ value });

        this.props.onChange(value);
    };

    focusInput = () => {
        this.input.current.focus();
    };

    handleFocus = () => {
        this.setState({ input_focused: true });
    };

    handleBlur = () => {
        this.setState({ input_focused: false });
    };

    render() {
        const {
            max_length,
            element_props,
            icon,
            mobile,
            className,
            t,
        } = this.props;
        const { value, input_focused } = this.state;

        const styles = getStyles(icon, max_length, input_focused);
        const classes = mobile ? styles.mobile : styles.desktop;

        return (
            <div className={className} onClick={this.focusInput}>
                <div className={classes.container} data-icon-before={icon}>
                    {// on mobile, an empty icon span must be placed before the input as a placeholder
                    mobile && icon && <span className="m2g-list-cell__icon" />}
                    <input
                        ref={this.input}
                        {...element_props}
                        className={classes.input}
                        maxLength={max_length}
                        value={value}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                    />
                    {icon && <span className={classes.icon} />}
                </div>
                {max_length && (
                    <div ref={this.counter} className={classes.counter}>
                        <span className="m2g-text--small m2g-text--offset">
                            {t('counter', {
                                length: value.length,
                                max_length,
                            })}
                        </span>
                    </div>
                )}
            </div>
        );
    }
}

export default forwardRefWithTranslation('textinput')(TextInput);
